import React, {useState} from 'react';
import {useSelector} from "react-redux";
import '../index.css'
import DictionaryAnswer from '../../Index/dictionaryAnswer'
import ErrorCorrectionAnswer from '../../ErrorCorrection/errorCorrectionAnswer'
import AnalysisAnswer from '../../Analysis/analysisAnswer'
import MarkDownApp from '../../../../comm/markDown'

const ChatAnswer = (props) =>  {

    const {answer,sendTxt,setSendTxt} = props
    const {allContextMeta} = useSelector(state => state.user)
    const data = answer[0]?.content;
    const {size} = useSelector(state => state.fontSizeChange)
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    }
    const [svgIndex, setSvgIndex] = useState([0])
    console.log(answer)
    return (
        <div>
                {
                    answer&&answer.length>0?
                    answer.map((res,i)=>{
                        return (
                            <div style={answerThree} key={'chat-n'+i}>
                                {
                                    res.content_type==='dictionary'?<DictionaryAnswer answer={answer} />:
                                        (
                                            res.content_type==='correcting'?<ErrorCorrectionAnswer answer={{responder_content:answer}}/>
                                            :(
                                                    res.content_type==='analysis'?
                                                        // <ErrorCorrectionAnswer answer={{responder_content:answer}}/>
                                                        <AnalysisAnswer answer={{responder_content:answer}} analysisMeta={allContextMeta.analysis_meta} ti={0} setSvgIndex={setSvgIndex} svgIndex={svgIndex} />
                                                        :<MarkDownApp value={res.text?res.text:res.content[0].text}></MarkDownApp>
                                                )
                                        )
                                }
                            </div>
                        )
                    }):''
                }
        </div>
    );
}


export default ChatAnswer
